var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFalse = function SvgIconFalse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M6.25 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5a7 7 0 0 0 0 14h9a7 7 0 1 0 0-14zm-5 7a5 5 0 0 1 5-5h9a5 5 0 0 1 0 10h-9a5 5 0 0 1-5-5"
  }))));
};
export default SvgIconFalse;